module.exports = __webpack_public_path__ + "img/crowdmarketing_logo.f90ee266.png";